export default __webpack_public_path__ + "55688093b6445f3248cf31b4b0f41768.png";